module.exports = __webpack_public_path__ + "static/images/containers/MigrationScreen/images/slide_2.03d0c5c1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MigrationScreen/images/slide_2.png
// module id = 3206
// module chunks = 11